/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * type of customer account
 * @export
 */
export const AccountType = {
    System: 'SYSTEM',
    Regular: 'REGULAR',
    Interim: 'INTERIM',
    Anonymous: 'ANONYMOUS'
} as const;
export type AccountType = typeof AccountType[keyof typeof AccountType];


export function AccountTypeFromJSON(json: any): AccountType {
    return AccountTypeFromJSONTyped(json, false);
}

export function AccountTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountType {
    return json as AccountType;
}

export function AccountTypeToJSON(value?: AccountType | null): any {
    return value as any;
}

